import styled from 'styled-components';
import ArrowDownIcon from '../../../../../Icons/ArrowDownIcon';

export const PriceBlockLoader = styled.div(
  props => `
  
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin: 0 auto;
    width:38.7rem;
    background-color:${props.theme.colors.white.base};
    border-radius:${props.theme.misc.borderRadius.xxlarge};
  
  `,
);

export const ArrowDownWrap = styled.div(
  props => `
    display:flex;
    justify-content:center;
    align-items:center;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:50%;
    height:2.6rem;
    width:2.6rem;
  `,
);

export const ArrowDown = styled(ArrowDownIcon)(
  props => `
    width:1rem;
    height:1rem;
    fill:${props.theme.colors.grey.grey50};
    `,
);

export const HeaderWithIconWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content: space-between;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.blue.bgBlue};
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.base};
  `,
);

export const TotalPriceWrap = styled.div(
  props => `
    display:flex;
    width:20rem;
    height:3rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  
  `,
);

export const TotalChargesOuterContainer = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    margin: ${props.theme.spacing.large.l15} ${props.theme.spacing.base} ${props.theme.spacing.base} ;
  `,
);

export const RoomLabelSpanOuter = styled.div(
  props => `
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.blue.bgBlue};
  `,
);

export const RoomLabelSpan = styled.div(
  props => `
    display:flex;
    width:20rem;
    height:2.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: ${props.theme.spacing.large.l15} ${props.theme.spacing.base} ${props.theme.spacing.base};
  
  `,
);

export const RoomChargesWrap = styled.div(
  props => `
    display:flex;
    width: 36.3rem;
    justify-content: space-between;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.base} 0 ${props.theme.spacing.base};
  
  `,
);

export const RoomChargesOuterContainer = styled.div(
  props => `
    display:flex;
    flex-direction:column;
  `,
);

export const RoomChargesLabel = styled.div(
  props => `
    display:flex;
    width:18.4rem;
    height:2.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.base} 0;
  
  `,
);

export const RoomChargesPrice = styled.div(
  props => `
    display:flex;
    width:9.7rem;
    height:2.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.base} 0;
  
  `,
);

export const DiscountWrap = styled.div(
  props => `
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    margin: 0 ${props.theme.spacing.base} ${props.theme.spacing.base};
    border-radius: ${props.theme.misc.borderRadius.base};
  `,
);
